import _map from 'lodash/map';
import _reject from 'lodash/reject';
import _uniqWith from 'lodash/uniqWith';
import APPCONFIG from '../../../constants/Config';
import {
  CPM_REGISTER_OPERATION,
  CPM_PURGE_OPERATIONS,
  CPM_UPDATE_STATUS_OPERATIONS,
  WS_RECEIVED_SUBSCRIPTION_DATA,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeOperation } from '../../../models/cpm/synchronization';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmOperation;
const operation = (state = initialSettings, action) => {
  let operationUpdated;
  switch (action.type) {
    case CPM_REGISTER_OPERATION:
      return {
        ...state,
        list: _uniqWith([...state.list, action.operation], (arrOperation, othOperation) => {
          const arrTargetKey = arrOperation.targetKey;
          const othTargetKey = othOperation.targetKey;
          return (arrOperation[arrTargetKey] === othOperation[othTargetKey] && arrOperation.id === othOperation.id);
        }),
      };
    case CPM_PURGE_OPERATIONS:
      return {
        ...state,
        list: _reject(state.list, ['targetKey', action.targetKey]),
      };
    case CPM_UPDATE_STATUS_OPERATIONS:
      return {
        ...state,
        list: _map(state.list, (o) => ({
          ...o,
          status: action.status,
          devices: _map(o.devices, (device) => ({
            ...device,
            error: action.error,
          })),
        })),
      };
    // Treat RECEIVED_SUBSCRIPTION_DATA from webSocket
    case WS_RECEIVED_SUBSCRIPTION_DATA:
      // Check that the subscription concerns an updated operation
      if (action.data && action.data.operationUpdated) {
        operationUpdated = deserializeOperation(action.data.operationUpdated);
        // Update the concerned operation
        return {
          ...state,
          list: _map(state.list, (o) => (o.id === operationUpdated.id ? { ...o, ...operationUpdated } : o)),
        };
      }
      return state;
    default:
      return state;
  }
};

export default operation;



// WEBPACK FOOTER //
// ./reducers/cpm/operation/operation.js